export default "__VITE_ASSET__xTDE7Bue__"